import { SEVERITY } from "helpers/utils.js";
import {
  GET_ORDER_NOTIFICATION_HISTORY,
  GET_ORDER_NOTIFICATION_HISTORY_SUCCESS,
  GET_ORDER_NOTIFICATION_HISTORY_FAIL,
} from "./actionTypes.js";

const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const OrderNotificationHistory = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ORDER_NOTIFICATION_HISTORY:
      return {
        ...state,
        loading: true,
      };
    case GET_ORDER_NOTIFICATION_HISTORY_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_ORDER_NOTIFICATION_HISTORY_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default OrderNotificationHistory;